import { ListOfShippingType } from "./ShippingsType.types";

import { IMessageBar } from "@/core/libs/message-bar";

export enum ShippingsTypeActionsTypes {
  CREATE_REQUEST = "shippingstype/CREATE_REQUEST",
  CREATE_FAIL = "shippingstype/CREATE_FAIL",
  CREATE_SUCCESS = "shippingstype/CREATE_SUCCESS",
  DISMISS_MESSAGE = "shippingstype/DISMISS_MESSAGE",
  EDIT_REQUEST = "shippingstype/EDIT_REQUEST",
  EDIT_FAIL = "shippingstype/EDIT_FAIL",
  EDIT_SUCCESS = "shippingstype/EDIT_SUCCESS",
  LIST_REQUEST = "shippingstype/LIST_REQUEST",
  LIST_FAIL = "shippingstype/LIST_FAIL",
  LIST_SUCCESS = "shippingstype/LIST_SUCCESS"
}

export interface ShippingsTypeState {
  isLoadingList: boolean;
  list: ListOfShippingType;
  message?: IMessageBar;
}

interface CreateRequest {
  type: ShippingsTypeActionsTypes.CREATE_REQUEST;
}

interface CreateError {
  type: ShippingsTypeActionsTypes.CREATE_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface CreateSuccess {
  type: ShippingsTypeActionsTypes.CREATE_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface DismissMessage {
  type: ShippingsTypeActionsTypes.DISMISS_MESSAGE;
}

interface EditRequest {
  type: ShippingsTypeActionsTypes.EDIT_REQUEST;
}

interface EditError {
  type: ShippingsTypeActionsTypes.EDIT_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface EditSuccess {
  type: ShippingsTypeActionsTypes.EDIT_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface ListRequest {
  type: ShippingsTypeActionsTypes.LIST_REQUEST;
}

interface ListError {
  type: ShippingsTypeActionsTypes.LIST_FAIL;
}

interface ListSuccess {
  type: ShippingsTypeActionsTypes.LIST_SUCCESS;
  payload: {
    list: ListOfShippingType;
  };
}

export type ShippingsTypeReducerActions =
  | CreateRequest
  | CreateError
  | CreateSuccess
  | DismissMessage
  | EditRequest
  | EditError
  | EditSuccess
  | ListRequest
  | ListError
  | ListSuccess;
